import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Flex from 'ui/Flex/Flex';
import { handleCheckboxChange } from '../helpers/onChange';
import { ModuleObjectT } from './helpers/types';

type ModuleCheckboxProps = {
    module: ModuleObjectT;
    modules: string[];
    checked: boolean;
    setModules: (modules: string[]) => void;
};

const ModuleCheckbox = ({
    module,
    modules,
    setModules,
    checked,
    children,
}: React.PropsWithChildren<ModuleCheckboxProps>) => {
    const { t } = useTranslation();
    const isModuleChecked = modules.includes(module.value);
    const { label, value, available } = module;
    return (
        <Flex sx={{ width: '200px' }} key={module.value} direction="column">
            <FormControlLabel
                label={t(label)}
                control={
                    <Checkbox
                        checked={checked}
                        disabled={!available}
                        onChange={() => {
                            handleCheckboxChange(value, modules, setModules);
                        }}
                    />
                }
            />
            {isModuleChecked && children}
        </Flex>
    );
};

export default React.memo(ModuleCheckbox);
